import { Link, useNavigate } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../components/Common/UI/Button';
import Label from '../../../../../../components/Common/UI/Label';
import { RadioGroup, RadioGroupItem } from '../../../../../../components/Common/UI/Radio';
import { cn } from '../../../../../../utils/styles';
import { Input } from '../../../../../../components/Common/UI/Input';

const radioGroupStyles = 'grid grid-cols-2 gap-4 max-w-[440px]';

function DualAuthDialog({ modalOpen, setModalOpen }: { modalOpen: boolean; setModalOpen: (val: boolean) => void }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);

  const [verificationCode, setVerificationCode] = useState('Hf1d*6hj');
  const [password, setPassword] = useState('Guidance12345!');
  const [showPassword, setShowPassword] = useState(false);

  const maskEmail = (email: string) => {
    const [name, domain] = email.split('@');

    if (name.length <= 2) return email;

    return `${name[0]}...${name[name.length - 1]}@${domain}`;
  };

  const emailOption = useMemo(() => {
    const viewerUpdatesRaw = localStorage.getItem('tempViewers');

    if (!viewerUpdatesRaw) return 'n...p@yahoo.com';

    const email = JSON.parse(viewerUpdatesRaw)[0]?.email;

    if (!email) return 'n...p@yahoo.com';

    return maskEmail(email);
  }, []);

  const handleToggleShowPass = () => {
    setShowPassword(prevState => !prevState);
  };

  const handleNextStep = () => {
    setStep(prevState => prevState + 1);
  };

  const steps: { content: React.ReactNode }[] = [
    {
      content: (
        <>
          <p>
            Our system detects that this is first time you use this device to visit us. For security purposes, we must
            confirm your identity. If you need any assistance, please contact our customer service representative at
            (650) 473-6388.
          </p>
          <p>
            Choose how you would like to receive the identity verification code and click “Next”. On the next page you
            will enter the identification code you receive.
          </p>

          <div>
            <div>
              <div className={radioGroupStyles}>
                <Label className="font-bold text-base text-secondary">Phone:</Label>
                <Label className="font-bold text-base text-secondary">Email:</Label>
              </div>

              <RadioGroup defaultValue="n...p@yahoo.com" className={radioGroupStyles} defaultChecked>
                {[
                  { value: 'XXX-XXX-1845', label: 'XXX-XXX-1845' },
                  { value: emailOption, label: emailOption },
                  { value: 'XXX-XXX-7251', label: 'XXX-XXX-7251' },
                ].map(({ value, label }) => (
                  <div key={value} className="flex items-center space-x-2 child:m-0">
                    <RadioGroupItem value={value} id={value} variant="secondary" />
                    <Label htmlFor={value} className={cn('text-sm')}>
                      {label}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </div>
          </div>

          <div className="bg-orange-50 text-[#EF9F00] rounded-[10px] px-5 py-7">
            <p>
              <b className="mr-1">Note:</b>
              We do not charge for text messages sent to your mobile device however, standard message and data rates may
              apply. If you select voice and your number requires an extension, we won’t be able to reach you.
            </p>
          </div>

          <div className="flex justify-end gap-4">
            <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="dark"
              className="py-3"
              onClick={() => {
                handleNextStep();
              }}
            >
              Next
            </Button>
          </div>
        </>
      ),
    },
    {
      content: (
        <>
          <h3 className="font-bold">Check Your Email / Phone</h3>
          <p>
            Haven’t Received your identification Code? We email identification code immediately, but many factors may
            influence how fast you receive them. Please check your spam folder to determine it was delivered there. If
            you need immediately please select another delivery option by clicking “Request a new identification Code”
            below.
          </p>
          <Link to="#" className="text-primary">
            Request New Verification Code
          </Link>
          <p>If you need any assistance, please contact our customer service representative at (650) 473-6388.</p>

          <div className="flex flex-col gap-4 child:flex-grow max-w-[325px]">
            <Input
              prefix="Enter Verification Code"
              variant="guidance"
              sizeVariant="lg"
              type={showPassword ? 'text' : 'password'}
              value={verificationCode}
              onChange={e => setVerificationCode(e.target.value)}
              icon={
                <Button
                  type="button"
                  size="auto"
                  variant="ghost"
                  onClick={handleToggleShowPass}
                  className="hover:text-slate-600"
                >
                  {showPassword ? <Icons.EyeFilled /> : <Icons.EyeFilled />}
                </Button>
              }
            />
            <Input
              prefix="Password"
              variant="guidance"
              type={showPassword ? 'text' : 'password'}
              sizeVariant="lg"
              value={password}
              onChange={e => setPassword(e.target.value)}
              icon={
                <Button
                  type="button"
                  size="auto"
                  variant="ghost"
                  onClick={handleToggleShowPass}
                  className="hover:text-slate-600"
                >
                  {showPassword ? <Icons.EyeFilled /> : <Icons.EyeFilled />}
                </Button>
              }
            />
          </div>

          <div>
            <div>
              <Label className="font-bold text-base text-secondary">Phone:</Label>

              <RadioGroup defaultValue="not-install" defaultChecked>
                {[
                  {
                    value: 'not-install',
                    label: 'DO NOT install any secure token on this public computer',
                  },
                  { value: 'install', label: 'Install a secure token on my own computer' },
                ].map(({ value, label }) => (
                  <div key={value} className="flex items-center space-x-2 child:m-0">
                    <RadioGroupItem value={value} id={value} variant="secondary" />
                    <Label htmlFor={value} className={cn('text-sm')}>
                      {label}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </div>
          </div>

          <div className="flex justify-end gap-4">
            <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="dark"
              className="py-3"
              onClick={() => {
                navigate('/guidance?unreviewed-document=yes');
                setModalOpen(false);
              }}
            >
              Submit
            </Button>
          </div>
        </>
      ),
    },
  ];

  const currentStepContent: React.ReactNode = useMemo(
    () => steps[step]?.content || 'Not found',
    [step, showPassword, password, verificationCode],
  );

  const handleClose = (isOpen: boolean) => {
    setStep(0);
    setModalOpen(isOpen);
  };

  return (
    <Dialog open={modalOpen} onOpenChange={handleClose}>
      <DialogContent className="guidance max-w-4xl max-h-[98%]">
        <DialogTitle className="flex items-center gap-4 mb-[10px]">
          <Icons.AccountsFilled className="size-[34px]" />
          <p className="text-xl leading-none">Dual Authentication Check</p>
        </DialogTitle>
        {currentStepContent}
      </DialogContent>
    </Dialog>
  );
}

export default DualAuthDialog;
